export const Role = {
    Admin: 'Admin',
    Mentor: 'Mentor'
}